import colors from 'styles/colors'
import { typography } from 'styles/typography'

export const defaultStyles = {
  container: {
    padding: '65px 0em',
    border: 0
  },
  returnText: {
    marginTop: 20,
    marginBottom: 15,
    cursor: 'pointer',
    ...typography.fontMedium,
    fontSize: 12,
    lineHeight: '16px',
    color: colors.primary
  },
  content: (isCareTeam) => {
    return {
      margin: '0 0 25px 0',
      overflow: 'hidden',
      borderRadius: 4,
      boxShadow: isCareTeam ? undefined : '0 5px 10px 0 rgba(0,0,0,0.06)',
      borderBottom: isCareTeam ? `3px solid ${colors.placebo}` : 0,
      backgroundColor: colors.white
    }
  },
  avatar: {
    marginRight: 38,
    height: '100%',
    boxSizing: 'border-box',
    borderRight: `1px solid ${colors.pixelWhite}`,
    objectFit: 'cover'
  },
  infoColumnContainer: (isCareTeam) => {
    return {
      padding: 0,
      paddingLeft: 38,
      boxSizing: 'border-box',
      borderRight: isCareTeam && `1px solid ${colors.pixelWhite}`
    }
  },
  buttonsContainer: (isMobile = false, isTablet = false) => {
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: (isMobile || isTablet) ? 'flex-start' : 'center',
      borderTop: (isMobile || isTablet) ? `1px solid ${colors.pixelWhite}` : 'none',
      background: colors.white
    }
  },
  button: {
    button: {
      width: '183px',
      marginBottom: 7
    }
  },
  secondaryButton: {
    button: {
      width: '183px',
      backgroundColor: colors.secondary
    }
  }
}
